export const primaryTheme = {
  color: {
    ashy: '#4A4A4A',
    black_21: '#212121',
    black: '#000000',
    grey: '#E5E5E5',
    darkGrey: '#696868',
    grey_d8: '#d8d8d8',
    grey_75: '#757575',
    grey_e0: '#e0e0e0',
    grey_dd: '#dddfe3',
    grey_83: ' #83868B',
    grey_b1: '#b1b1b1',
    white: '#FFFFFF',
    white_f8: '#f8f8f8',
    white_f7: '#f7f7f7',
    white_de: '#dee2eb',
    white_e5e: '#e5ecff',
    white_ede: '#edeff3',
    darkBlue: '#0c32cd',
    sky: '#F1FCFF',
    blue: '#2196F3',
    blue_c4: '#c4d1ff',
    blue_c0: '#1164C0',
    brightBlue: '#033aff',
    dirtyBlue: '#F1FCFF',
    cornflower: '#A0B0B9',
    lightBlue: '#e5ecff',
    blue_dd: '#dde7ff',
    lavender: '#d1dbff',
    brightLavender: '#a1b3f9',
    red: '#e41700',
    lightRed: '#f74c39',
    green: '#008000',
    lightGreen: '#7ce7a0',
    brown: '#522b2b',
    lightBrown: '#b3abab',
  },
  fontSize: {
    XS: '12px',
    S: '13px',
    M: '14px',
    L: '22px',
    XL: '24px',
    XXL: '44px',
  },
  fontWeight: {
    NORMAL: 'normal',
    SEMI_BOLD: '600',
  },
  shadow: {
    main: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  },
};
